<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M16 4 L17.6 12.5 L26 16 L17.6 19.5 L16 28 L14.4 19.5 L6 16 L14.4 12.5 Z" />
    <circle
      cx="25"
      cy="7"
      r="1.6"
      fill-opacity=".7"
    />
    <circle
      cx="7"
      cy="25"
      r="1.2"
      fill-opacity=".55"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconIntentRelaxed',
  props: { size: { type: [String, Number], default: 22 } },
};
</script>
